const _excluded = ["className", "color", "SvgElement", "height", "width", "title"],
  _excluded2 = ["style"],
  _excluded3 = ["style"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from 'react';
import classNames from 'clsx';
import { AlignTarget } from "../Align";
import Box from "../Box";
import extractDimensions from "./extractDimensions";
import getColorClassnames from "../Icon/getColorClassnames";
class SVG extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  componentDidCatch() {
    this.setState({
      hasError: true
    });
  }
  render() {
    if (this.state.hasError) {
      return /*#__PURE__*/React.createElement("span", null);
    }
    const _this$props = this.props,
      {
        className,
        color,
        SvgElement,
        height: h = 0,
        width: w = 0,
        title
      } = _this$props,
      props = _objectWithoutProperties(_this$props, _excluded);
    const {
      height,
      width
    } = extractDimensions(SvgElement, h, w);
    const colorClasses = getColorClassnames(color);
    const classes = classNames('SVGInline', 'SVGInline--cleaned', 'SVG', className, colorClasses);
    return /*#__PURE__*/React.createElement(AlignTarget, _extends({}, props, {
      strategy: "center",
      lineHeight: height
    }), alignProps => {
      const {
          style: propStyle = {}
        } = props,
        svgProps = _objectWithoutProperties(props, _excluded2);
      const {
          style: alignStyle = {}
        } = alignProps,
        svgAlignProps = _objectWithoutProperties(alignProps, _excluded3);
      return /*#__PURE__*/React.createElement(Box, _extends({}, props, {
        style: _objectSpread(_objectSpread({}, propStyle), alignStyle),
        title: title,
        flex: true,
        className: classes
      }), /*#__PURE__*/React.createElement(SvgElement, _extends({}, svgProps, svgAlignProps, {
        className: classes.split(/\s+/).map(cl => `${cl}-svg`).join(' '),
        height: height,
        width: width
      })));
    });
  }
}
export default SVG;